import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=68d7631a&scoped=true"
import script from "./slide.vue?vue&type=script&lang=js"
export * from "./slide.vue?vue&type=script&lang=js"
import style0 from "./slide.vue?vue&type=style&index=0&id=68d7631a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d7631a",
  null
  
)

export default component.exports